module.exports = __webpack_public_path__ + "static/media/orlen_the_latest.71ff7730.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/orlen_the_latest.svg
// module id = 643
// module chunks = 0